<template>
  <div class="login">
    <!-- <img class="mobile-background" src="@/assets/login-background-mobile.png" alt /> -->
    <!-- <img class="cover-small" src="@/assets/funweek/bg-small.jpg" alt="" /> -->
    <login-auth-container class="login-container" :authType="$route.params.type" />
    <!-- <illustration-mosaic /> -->
    <!-- <div class="cover"></div> -->
  </div>
</template>

<script>
import windowStore from '@/store/modules/window.store'

const LOGIN_TYPES = [
  // 'phone',
  'signup',
  'reset',
  'forgot'
]

if (windowStore.state.countryCode === 'US') {
  LOGIN_TYPES.push('playphone')
  LOGIN_TYPES.push('playphone-last-step')
}

export default {
  name: 'login',
  beforeRouteEnter(to, from, next) {
    if (!to.params.type || LOGIN_TYPES.includes(to.params.type)) {
      return next()
    }

    next({ name: 'login' })
  }
}
</script>

<style lang="scss" scoped>
.login {
  overflow-x: hidden;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 2rem;
}
.login-container {
  display: flex;
  justify-items: center;
  flex-direction: column;

  @media screen and (min-width: 568px) {
    flex-direction: row;

    & > .mobile-background {
      display: none;
    }

    & > .illustration-mosaic {
      display: inline-flex;
    }

    .cover-small {
      display: none;
    }
    .cover {
      display: block;
      width: 728px;
      background: {
        image: url('~@/assets/funweek/bg-large.jpg');
        position: 100% 30px;
        repeat: no-repeat;
        size: 100% auto;
      }
    }
  }
}
</style>
